const base = 'utils/';

const UtilsApi = {
  base,
  assignDetails: base + 'assign-details'
};

export default UtilsApi;
